$(function () {
    const $coverage = $('.solutions.coverage');
    const $radios   = $('.solutions.industry input[type="radio"]');

    if (!$coverage.length) {
        // No coverage area → disable industry radios
        $radios.prop('disabled', true).closest('.solutions__tile__wrapper').addClass('is-disabled');
        return;
    }

    const $tiles = $coverage.find('.solutions__tile__wrapper');

    if ($('.solutions').length > 1) {
        $radios.on('change', function () {
            const selectedValues = $radios.filter(':checked').map(function () {
                return this.value;
            }).get();

            if (selectedValues.length === 0) {
                $tiles.show();
            } else {
                $tiles.each(function () {
                    const $tile = $(this);
                    $tile.toggle(selectedValues.includes($tile.data('category')));
                });
            }
        });

        // Apply filter if a radio is already checked on load
        const $checked = $radios.filter(':checked');
        if ($checked.length) {
            $checked.trigger('change');
        }
    }
});
